import { observer } from 'mobx-react-lite';
import { useEffect, useLayoutEffect, useRef } from 'react';

import { FEATURES, useFeature } from '@/features/feature-flags';
import { logError } from '@/lib/errorLogging';

import { agentsStore } from './agents.store';

export const AgentsEffects = observer(() => {
  const agentsEnabled = useFeature()(FEATURES.AGENTS_UX);

  useLayoutEffect(() => {
    document.body.dataset.themeSet = 'next';
    return () => {
      delete document.body.dataset.themeSet;
    };
  }, []);

  useEffect(() => {
    if (agentsEnabled) agentsStore.resumePendingSends();
  }, [agentsEnabled]);

  const defaultTeamRequested = useRef(false);
  const isRosterLoaded = agentsStore.isRosterLoaded;
  useEffect(() => {
    if (!agentsEnabled || !isRosterLoaded || defaultTeamRequested.current)
      return;
    defaultTeamRequested.current = true;
    agentsStore.addDefaultTeam().catch((error: unknown) => {
      defaultTeamRequested.current = false;
      logError(error, 'Failed to add the default team', {
        context: 'AgentsEffects',
      });
    });
  }, [agentsEnabled, isRosterLoaded]);

  return null;
});
